var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_SelectTheApprovalPosition"),
        "before-close": _vm.cancel,
        width: "660px",
        "append-to-body": ""
      }
    },
    [
      _c(
        "div",
        { staticClass: "grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "400px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.workflowTypes
            }
          })
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSave } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
            ),
            _c("el-button", { on: { click: _vm.cancel } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
            ])
          ],
          1
        )
      ]),
      _c("bill-payment-apply-form", {
        attrs: {
          visible: _vm.fromDialog.visible,
          "workflow-title": _vm.fromDialog.name
        },
        on: {
          close: function($event) {
            _vm.fromDialog.visible = false
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }